import React, { Component } from 'react'
import gql from 'graphql-tag'
import { Row, Col, Alert, Progress, Label, Button, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import "./AddToDidntTakeCar.css"

import ConnectionSelect from '../Components/ConnectionSelect'
import withApolloClient from '../withApolloClient'

const addToDidntTakeCarMutation = gql`
mutation addToDidntTakeCarMutation($input: AddToDidntTakeCarMutationInput!){
    addToDidntTakeCar(input:$input){
    ok
    errors{
        messages
    }
}
} `
const AllDidntTakeCarReason = gql`
    query allDidntTakeCarReason($first: Int, $searchTerm: String, $filters: [FilterInput]){
        allDidntTakeCarReason(first:$first, searchTerm:$searchTerm, filters:$filters, orderBy:["name"]){
            edges{
                node{
                    id
                    name
                }
            }
      }
    }
`
const ACTIVE_REASON_FILTERS = [
    { fieldName: "is_active", filterType: "equal", filterValues: "true" },
]
const getDidntTakeCarReasonConnection = (data) => data ? data.allDidntTakeCarReason : null
const getDidntTakeCarReasonOption = (node) => ({ label: node.name, value: node.id })

class AddToDidntTakeCar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            error: null,
            addedToDidntTakeCar: false,
            openModal: "",
            reason: null
        }
    }
    handleClose = (e) => {
        //Reset state
        let state = {
            loading: false,
            error: null,
            addedToDidntTakeCar: false,
            openModal: "",
            reason: null
        }
        this.setState({ ...state })
        this.props.handleClose()
    };
    addToDidntTakeCar = () => {
        this.setState({ loading: true })
        let input = {
            driverId: this.props.driverId ? this.props.driverId : "",
            reasonId: this.state.reason
        }

        this.props.apolloClient.mutate({
            mutation: addToDidntTakeCarMutation,
            variables: { input },
        }).then((result) => {
            if (result.data && result.data.addToDidntTakeCar && result.data.addToDidntTakeCar.ok) {
                this.setState({ addedToDidntTakeCar: true, error: null, loading: false })
                if (this.props.refetchQuery) {
                    this.props.refetchQuery()
                    this.handleClose()
                }
            } else if (result.data && result.data.addToDidntTakeCar.errors && result.data.addToDidntTakeCar.errors.length > 0) {
                this.setState({ loading: false, addedToDidntTakeCar: false, error: result.data.addToDidntTakeCar.errors[0].messages[0] })
            } else {
                this.setState({ loading: false, addedToDidntTakeCar: false, error: "An error has occured. Please contact the admin." })
            }
        }).catch((error) => {
            let errorMessage = "An error has occured. Please contact the admin."
            this.setState({ error: errorMessage, loading: false, addedToDidntTakeCar: false, })
        })
    };
    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "" })
        } else {
            this.setState({ openModal: modalName })
        }
    }
    componentDidMount() {
        const { apolloClient } = this.props
    }

    render() {
        return (

            <Modal className="dtac-modal" isOpen={this.props.open}>
                {this.props.driverId &&
                    <>
                        <ModalHeader className="dtac-modal-header">Add driver to didn't take car</ModalHeader>
                        <ModalBody>
                            {this.state.error && !this.state.addedToDidntTakeCar && <Row><Col xs={12}><Alert color="danger">{this.state.error}</Alert></Col></Row>}
                            {this.state.addedToDidntTakeCar && !this.state.error && <Row><Col xs={12}><Alert color="success">Added to didnt take a car successfully!</Alert></Col></Row>}
                            {!this.state.addedToDidntTakeCar &&
                                <Row>
                                    <Col xs={12}>
                                        <FormGroup>
                                            <Label>Reason <span aria-hidden="true">*</span></Label>
                                            <ConnectionSelect
                                                query={AllDidntTakeCarReason}
                                                variables={{ filters: ACTIVE_REASON_FILTERS }}
                                                getConnection={getDidntTakeCarReasonConnection}
                                                getOption={getDidntTakeCarReasonOption}
                                                value={this.state.reason}
                                                onChange={(reason) => this.setState({ reason })}
                                                placeholder="Search or select a reason"
                                                isClearable={false}
                                            />
                                            <div className="dtac-search-hint">
                                                Search by name if the reason is not listed.
                                            </div>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            }
                            {this.state.loading && <Row><Col xs={12}><Progress animated color="info" value="100" /></Col></Row>}
                        </ModalBody>
                    </>}
                <ModalFooter>
                    {!this.state.loading &&
                        <>
                            <Button className="dtac-modal-secondary-btn" onClick={this.handleClose}>Close</Button>
                            <Button className="dtac-modal-primary-btn" onClick={this.addToDidntTakeCar} disabled={!this.state.reason || this.state.addedToDidntTakeCar || this.state.loading}>Add to didn't take car</Button>
                        </>
                    }
                </ModalFooter>
            </Modal>
        )
    }
}


export default withApolloClient(AddToDidntTakeCar)
